import React from "react";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";
import "./_toastify.scss";
import "./_loader.scss";
import { Spinner } from "reactstrap";
// import FormCard from "../components/cards/FormCard";

export const emptyObject = {};
export const emptyArray = [];
export const identityFn = x => x;

export const openToast = ({ text, type }) => {
  Toastify({
    text,
    duration: 2000,
    close: true,
    gravity: "top", // `top` or `bottom`
    position: "right", // `left`, `center` or `right`
    stopOnFocus: true, // Prevents dismissing of toast on hover
    className: type === "success" ? "toast-success" : "toast-error"
  }).showToast();
};

export function Loader(props) {
  const { className, ...restProps } = props;
  return (
    <div className="position-relative">
      <div
        className={`loader-bg position-absolute h-0 ${className}`}
        {...restProps}
      >
        <Spinner color="primary" />
      </div>
    </div>
  );
}

export function FullPageLoader(props) {
  const { className, ...restProps } = props;
  return (
    <div className="">
      <div className={`loader-bg ${className}`} {...restProps}>
        <Spinner color="primary" />
      </div>
    </div>
  );
}

// export const FormCardLoader = ({ message }) => (
//   <FormCard>
//     {message ? <strong>{message}</strong> : <Spinner color="primary" />}
//   </FormCard>
// );

const messages = {
  successCreate: "Success", //Successfully created
  successDelete: "Successfully deleted",
  successEdit: "Successfully edited",
  error500: "Something went wrong. Please try again later."
};

export const showMessage = message => messages[message];

export const typeMap = {
  1: "speakers",
  2: "exhibitors"
};
